import apiService from '../apiService'

export const buyermangeController = configService => {
  const service = apiService(configService)

  return {
    BuyerList: data => {
      return service.get({
        url:
          'cms/admin/buyer?status=' +
          data.status +
          '&keyword=' +
          data.keyword +
          '&page=' +
          data.page +
          '&limit=10',
      })
    },
    BuyerListSort: data => {
      return service.get({
        url:
          'cms/admin/buyer?status=' +
          data.role_id +
          '&keyword=' +
          data.keyword +
          '&page=' +
          data.page +
          '&sort_by=' +
          data.sort_name +
          '&order_by=' +
          data.sort_by +
          '&limit=10',
      })
    },
    verifyTaxID: id => {
      return service.get({
        url: 'auth/admin/verifyTaxID/' + id,
      })
    },
    createBuyer: params => {
      return service.post({
        url: 'cms/admin/buyer',
        params,
      })
    },
    getBuyer: id => {
      return service.get({
        url: 'cms/admin/buyer/' + id,
      })
    },
    updateBuyer: params => {
      return service.put({
        url: 'cms/admin/buyer',
        params,
      })
    },
    updateBuyerStatus: params => {
      return service.put({
        url: `cms/buyer/updateBuyerStatus`,
        params,
      })
    },
    resendEmail: params => {
      return service.post({
        url: `cms/admin/buyer/resendEmail`,
        params,
      })
    },
  }
}
